import React from "react";
import type { ReactNode } from "react";
import { Label as LabelAria, RadioGroup as RadioGroupAria, Text } from "react-aria-components";
import type { RadioGroupProps, ValidationResult } from "react-aria-components";

import { cn } from "@/lib/helpers/cn";

import { Heading2 } from "../atoms/Heading";
import { FieldError2 } from "../atoms/FieldError";

export type RadioGroup2Props = {
  children?: ReactNode;
  classNameChildren?: string;
  classNameWrapper?: string;
  description?: string;
  errorMessage?: ((validation: ValidationResult) => string) | string;
  label?: string;
} & Omit<RadioGroupProps, "children">;

export function RadioGroup2({
  children,
  classNameChildren,
  description,
  errorMessage,
  label,
  ...props
}: RadioGroup2Props) {
  return (
    <RadioGroupAria className="tw:flex tw:flex-col tw:gap-3" {...props}>
      <LabelAria>
        <Heading2 size={2}>{label}</Heading2>
      </LabelAria>

      <div className={cn("tw:flex tw:flex-col tw:gap-2 tw:[&>label]:mb-0!", classNameChildren)}>
        {children}
      </div>

      {description && (
        <Text slot="description">
          <small>{description}</small>
        </Text>
      )}

      <FieldError2>{errorMessage}</FieldError2>
    </RadioGroupAria>
  );
}
